import { useMutation, useQueryClient } from '@tanstack/react-query';
import { generateAiVisibilityReport } from '../../services/ai-visibility-report/AiVisibilityReportService';
import {
  GET_AI_VISIBILITY_REPORTS,
  GET_AI_VISIBILITY_RUNS,
  GET_AI_VISIBILITY_USAGE,
} from '../../query/ai-visibility-report/keys';

export const useGenerateAiVisibilityReport = (
  projectId: number,
  options?: { onSuccess?: () => void }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ from, to }: { from: string; to: string }) =>
      generateAiVisibilityReport(projectId, from, to),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_RUNS, projectId] });
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_REPORTS, projectId] });
      // A new run immediately consumes a quota slot (PENDING already counts).
      void queryClient.invalidateQueries({ queryKey: [GET_AI_VISIBILITY_USAGE] });
      options?.onSuccess?.();
    },
  });
};
